<template>
  <div class="page-wrapper" :class="layoutobj">
    <div v-if="!togglesidebar" class="mobile-menu-toggle" title="Mở menu" @click="toggle_sidebar">
      <vue-feather type="menu"></vue-feather>
    </div>
    <div class="page-body-wrapper horizontal-menu">
      <div class="bg-overlay" :class="{ active: activeoverlay }" @click="removeoverlay()"></div>
      <div v-if="togglesidebar" class="sidebar-edge-toggle" title="Thu gọn menu" @click="toggle_sidebar">
        <vue-feather type="chevrons-left"></vue-feather>
      </div>
      <header class="main-nav" :class="[{ close_icon: !togglesidebar, 'sidebar-mini': !sidebarPinned }]"
        :sidebar-layout="layout.settings.sidebar_setting">
        <Sidebar @clicked="sidebar_toggle" />
      </header>
      <div class="page-body">
        <router-view v-slot="{ Component }">
          <transition name="fadeIn" enter-active-class="animated fadeIn">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
      <footerView />
    </div>
    <customizer />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { layoutClasses } from '../constants/layout';
import Header from './header/indexView.vue';
import Sidebar from './slidebar/indexVue.vue';
import customizer from "./customizer/index.vue"
import footerView from "./footerView.vue"
export default {
  components: {
    Header,
    Sidebar,
    customizer,
    footerView
  },
  data() {
    return {
      mobileheader_toggle_var: false,
      sidebar_toggle_var: false,
      horizontal_Sidebar: true,
      resized: false,
      layoutobj: {}
    };
  },
  computed: {
    ...mapState({
      menuItems: state => state.menu.data,
      layout: state => state.layout.layout,
      togglesidebar: (state) => state.menu.togglesidebar,
      sidebarPinned: (state) => state.menu.sidebarPinned,
      activeoverlay: (state) => state.menu.activeoverlay
    }),
    layoutobject: {
      get: function () {
        return JSON.parse(JSON.stringify(layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout)))[this.layout.settings.layout];
      },
      set: function () {
        this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layout.settings.layout];
        return this.layoutobj;
      }
    }
  },
  watch: {
    '$route'() {
      this.menuItems.filter(items => {
        if (items.path === this.$route.path)
          this.$store.dispatch('menu/setActiveRoute', items);
        if (!items.children) return false;
        items.children.filter(subItems => {
          if (subItems.path === this.$route.path)
            this.$store.dispatch('menu/setActiveRoute', subItems);
          if (!subItems.children) return false;
          subItems.children.filter(subSubItems => {
            if (subSubItems.path === this.$route.path)
              this.$store.dispatch('menu/setActiveRoute', subSubItems);
          });
        });
      });
      this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
      if ((window.innerWidth < 991 && this.layout.settings.layout === 'LosAngeles') || (window.innerWidth < 991 && this.layout.settings.layout === 'Singapore') || (window.innerWidth < 991 && this.layout.settings.layout === 'Barcelona')) {
        const newlayout = JSON.parse(JSON.stringify(this.layoutobj).replace('horizontal-wrapper', 'compact-wrapper'));
        this.layoutobj = JSON.parse(JSON.stringify(newlayout))[this.layout.settings.layout];
      } else {
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layout.settings.layout];
      }
    },
    sidebar_toggle_var: function () {
      this.resized = (window.innerWidth <= 991) ? !this.sidebar_toggle_var : this.sidebar_toggle_var;
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.$store.dispatch('layout/set');

    this.layout.settings.layout = this.$route.query.layout ? this.$route.query.layout : 'Defaul';
    this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
    this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layout.settings.layout];
  },
  methods: {
    sidebar_toggle(value) {
      this.sidebar_toggle_var = !value;
    },
    mobiletoggle_toggle(value) {
      this.mobileheader_toggle_var = value;
    },
    handleResize() {
      this.$store.dispatch('menu/resizetoggle');
      this.resized = window.innerWidth <= 1000;
    },
    removeoverlay() {
      this.$store.state.menu.activeoverlay = false;
      if (window.innerWidth < 1001) {
        this.$store.state.menu.togglesidebar = false;
      }
      this.menuItems.filter(menuItem => {
        menuItem.active = false;
      });
    },
    hidesecondmenu() {
      if (this.layoutobject.split(' ').includes('compact-sidebar')) {
        this.menuItems.filter(menuItem => {
          menuItem.active = false;
        });
      }
      if (window.innerWidth < 991) {
        this.$store.state.menu.togglesidebar = false;
      }
    },
    toggle_sidebar() {
      this.$store.dispatch('menu/opensidebar');
    }
  }
};
</script>
<style scoped>
.page-body-wrapper.horizontal-menu {
  height: 100vh;
}

.mobile-menu-toggle {
  position: fixed;
  top: 15px;
  left: 15px;
  z-index: 10;
  cursor: pointer;
  background: #fff;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  color: var(--theme-deafult);
  transition: all 0.3s ease;
}

.mobile-menu-toggle:hover {
  transform: scale(1.1);
  background: rgba(var(--theme-deafult), 0.05);
}

.mobile-menu-toggle svg {
  width: 24px;
  height: 24px;
}

.sidebar-edge-toggle {
  position: fixed;
  top: 30px;
  left: 276px; /* mép phải menu (290px) - nửa nút */
  z-index: 1003;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  background: #fff;
  border: 1px solid #e6edef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  color: var(--theme-deafult);
  transition: all 0.2s ease;
}

.sidebar-edge-toggle:hover {
  transform: scale(1.1);
}

.sidebar-edge-toggle svg {
  width: 16px;
  height: 16px;
}

.bg-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  z-index: 1000;
}

.bg-overlay.active {
  display: block;
}

header.main-nav {
  z-index: 1001 !important;
  top: 0 !important; /* Force top alignment */
}

/* Ensure secondary parts of the menu are also on top */
.main-navbar {
  z-index: 1002 !important;
}

@media (max-width: 1000px) {
  .page-body-wrapper.horizontal-menu .page-body {
    margin-top: 0 !important; /* Remove top margin on mobile if needed */
  }
}

/* Desktop dùng nút ghim cạnh logo thay cho nút thu gọn */
@media (min-width: 1200px) {
  .sidebar-edge-toggle {
    display: none;
  }
}

</style>
<style>
/* Menu thu gọn (bỏ ghim): chỉ còn icon, hover thì bung full đè lên nội dung */
@media (min-width: 1200px) {
  .page-wrapper.compact-wrapper .page-body-wrapper header.main-nav ~ .page-body,
  .page-wrapper.compact-wrapper .page-body-wrapper header.main-nav ~ footer {
    transition: margin-left 0.3s ease;
  }

  .page-wrapper.compact-wrapper .page-body-wrapper header.main-nav.sidebar-mini {
    width: 87px; /* li 20 + a(15 + icon 16 + 15) + li 20 + border 1 */
    overflow-x: hidden;
  }

  .page-wrapper.compact-wrapper .page-body-wrapper header.main-nav.sidebar-mini:hover {
    width: 290px;
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.12);
  }

  .page-wrapper.compact-wrapper .page-body-wrapper header.main-nav.sidebar-mini ~ .page-body,
  .page-wrapper.compact-wrapper .page-body-wrapper header.main-nav.sidebar-mini ~ footer {
    margin-left: 87px;
  }

  header.main-nav.sidebar-mini .nav-menu a,
  header.main-nav.sidebar-mini .sidebar-user {
    white-space: nowrap;
  }

  header.main-nav.sidebar-mini:not(:hover) .sidebar-logo {
    width: 58px;
  }

  header.main-nav.sidebar-mini:not(:hover) .sidebar-pin-toggle,
  header.main-nav.sidebar-mini:not(:hover) .nav-menu > li > a > span,
  header.main-nav.sidebar-mini:not(:hover) .nav-menu > li > a > .according-menu,
  header.main-nav.sidebar-mini:not(:hover) .nav-menu > li > a > svg:not(:first-child),
  header.main-nav.sidebar-mini:not(:hover) .sidebar-main-title h6,
  header.main-nav.sidebar-mini:not(:hover) .user-info-col,
  header.main-nav.sidebar-mini:not(:hover) .wallet-mini-card {
    display: none !important;
  }

  header.main-nav.sidebar-mini:not(:hover) .nav-menu .nav-submenu {
    display: none !important;
  }

  /* Ẩn thanh cuộn khi co để nó không ăn mất 6px bên phải làm lệch nền active */
  header.main-nav.sidebar-mini:not(:hover) .nav-menu {
    scrollbar-width: none;
  }

  header.main-nav.sidebar-mini:not(:hover) .nav-menu::-webkit-scrollbar {
    width: 0 !important;
  }

  header.main-nav.sidebar-mini:not(:hover) .user-main-row {
    justify-content: center !important;
  }
}
</style>
